import type { FaireProductEntity } from "../../entity_types/product";

export const p_rerfp7dvds: FaireProductEntity = {
  token: "p_rerfp7dvds",
  type: "product",
  name: "Little Women Inspired - Lavender Chamomile HERBAL TEA",
  brandName: "NovelTea Bookstore & Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/d838da8dd984865a1b1c0e237d1d2bb51c88bff76a7368fd88eb82c13374a628.jpeg",
  priceDollars: 2,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/512c97000d7a8eec105bccd93a95df23fa6dff897f20730f06cd8f8eb3b54c1f.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
